import { ref } from 'vue';
import { useGetGroup, useGroupMembers } from '@ilteducation/customer-mgmt';
import { GetUsersResponse, GetGroupResponse } from '@ilteducation/customer-mgmt-types';

const group = ref<GetGroupResponse | null>(null);
const members = ref<GetUsersResponse['data'] | null>(null);
const isMembersLoading = ref<boolean>(false);
const isGroupLoading = ref<boolean>(false);
export const useSidebarGroup = () => {
  const { loadGroup } = useGetGroup();
  const { loadAllMembers } = useGroupMembers();

  const loadGroupProfile = async (uid: string) => {
    if (isGroupLoading.value) {
      return;
    }
    group.value = null;
    isGroupLoading.value = true;
    const fetchedGroup = await loadGroup(uid);
    group.value = fetchedGroup;
    isGroupLoading.value = false;
  };

  const getMembers = async (uid: string) => {
    if (isMembersLoading.value) {
      return;
    }

    isMembersLoading.value = true;
    members.value = null;
    const fetchedGroup = await loadAllMembers(uid);
    members.value = fetchedGroup;
    isMembersLoading.value = false;
  };

  const getGroup = async (groupUid: string, reFetch: boolean = false) => {
    if (reFetch || !group.value || group.value.uid !== groupUid) {
      await Promise.all([loadGroupProfile(groupUid), getMembers(groupUid)]);
    }
  };

  return {
    group,
    members,
    isMembersLoading,
    isGroupLoading,
    getGroup,
    getMembers,
  };
};
